// extracted by mini-css-extract-plugin
module.exports = {"menuWrapper":"LlgkK__menuWrapper","menuItemWrapper":"_3VDJc__menuItemWrapper","menuItem":"_3rQc5__menuItem"};